// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vy_a bhk_b bhk_wb"};